import {UserSessionReq} from "../../shared/interfaces/user-session-req-interface";

export interface CargoItem {
    numeroDocumento: string | null | undefined;
    montoTramite: number;
    ordenPago: string | null | undefined;
    nombreSolicitante: string | null | undefined;
    idTramite: string;
    nombreTramite: string;
    dependenciaServicio: string;
    codigoCargo?: string;
    numeroReferencia?: string;
    fechaHoraRegistro?: string;
    codigoRespuesta?: string;
    mensajeRespuesta?: string;
    session: UserSessionReq,
    idInstitucion: number;
    idProyecto: number
    idSolicitud: number
    idMetodoPago: number
    data: TarjetaItem
    items: CargoItemDet[]
}

export interface CargoItemDet {
    idTramite: string
    nombre: string
    monto: number
}

export interface HistorialMovimientosInterface {
    tipoTransaccion: string;
    refTransaccion: string;
    nombres: string;
    apellidos: string;
    banco: string;
    abono: string;
    cargo: string;
    fechaAbono: Date | string;
    fechaCargo: Date | string;
    codigoBanco: string;
    tipoDocumento: string;
    numeroDocumento: string;
    uniqueAppID?: string;
    metodoPago?: string;
}

export interface NoResultadosInterface {
    codigo: string;
    mensaje: string;
}

export interface TramiteFormularioInterface {
    idTramite: number;
    idInstitucion: number;
    idFormulario: number;
    nombre: string;
    rutaFormulario: string;
    fechaCreacion: Date;
    estado: boolean;
}

export interface TarifarioInterface {
    idTarifario?: number;
    idTarifarioDet?: number;
    idProyecto?: string | null;
    idEntorno: number;
    idTramite: number;
    idTipoArea: number;
    area: number;
    total?: number | null;
    fechaCreacion?: String;
    estado?: number;
    creadoPor?: String | null;
    idInstitucion?: number;
    idSolicitud?: number,
}

export interface SaldoCta {
    codigoCuentaIndividual: string;
    numeroDocumento: string;
    tipoDocumento: string;
    nombres: string;
    apellidos: string;
    saldo: number;
    codigoComunes: string;
    codigoECNR: string;
}

export const defaultSaldoCta: SaldoCta = {
    codigoCuentaIndividual: "",
    numeroDocumento: "",
    tipoDocumento: "",
    nombres: "",
    apellidos: "",
    saldo: 0,
    codigoComunes: "",
    codigoECNR: ""
};

export interface TarjetaFrm {
    idMetodoPago: number;
    data: TarjetaItem
}

export interface TarjetaItem {
    nombre: string;
    numero: string
    fechaExpiracion: string;
    cvv: string;
}
